import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SlideInPanel from '../SlideInPanel';
import StoryImporter from '../../pages/subPages/StoryImporter';
import { fetchFullBook } from '../../slices/storyEditorSlice';
import importStory from '../../assets/importStory.svg'

/**
 * ImportStoryPanel Component
 * Panel for importing stories using the StoryEditor component
 */
const ImportStoryPanel = ({ isOpen, onClose, onSuccess, litGroup, book }) => {
  const dispatch = useDispatch();

  // Pre-load book data when panel opens with a book selected
  useEffect(() => {
    if (isOpen && book?.uuid) {
      // Fetch the full book data for the StoryEditor
      dispatch(fetchFullBook({
        userId: '', // Will be handled by StoryEditor from user profile
        bookUuid: book.uuid
      }));
    }
  }, [isOpen, book, dispatch]);

  // Handle panel close
  const handleClose = () => {
    onClose();
    // Optionally clear story editor state
  };

  const panelTitle = book && litGroup
    ? `Import Story PDF for: ${book.name}`
    : 'Story Importer';

  return (
    <SlideInPanel
      isOpen={isOpen}
      onClose={handleClose}
      title={panelTitle}
      width="1100px" // Wider panel for StoryEditor content
      headerImg={importStory}
    >
      <div style={{
        padding: '0',
        margin: '-1.5rem', // Compensate for panel padding
        height: '100%'
      }}>
        {/* Render the StoryImporter component */}
        <StoryImporter
          titleText={panelTitle}
          preSelectedBook={book}
          preSelectedLitGroup={litGroup}
        />
      </div>
    </SlideInPanel>
  );
};

export default ImportStoryPanel;
